import React, { SVGProps } from "react";

export default function SupWithdraw(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.3073 14.8703L12 12.5191L12.6146 13.0312L9.90729 16.5999L7.2 13.0312L7.81458 12.5191L9.50729 14.8703V12.5999H10.3073V14.8703Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2064 6.90555C11.5696 7.27035 12.1072 7.71195 12.1072 8.70075C12.1072 9.73755 11.3392 10.4384 10.2064 10.5248V11.3024H9.6304V10.5248C8.824 10.4576 8.2096 10.1504 7.4704 9.50715L7.9408 8.96955C8.6512 9.59355 9.1312 9.80475 9.6304 9.85275V7.48155C8.2384 7.10715 7.7776 6.74235 7.7776 5.82075C7.7776 4.87995 8.5936 4.22715 9.6304 4.14075V3.37275H10.2064V4.15035C10.9168 4.20795 11.4832 4.47675 12.0784 5.01435L11.608 5.54235C11.08 5.06235 10.6768 4.87035 10.2064 4.81275V6.90555ZM9.6304 4.80315C8.9392 4.87995 8.5072 5.28315 8.5072 5.80155C8.5072 6.35835 8.8912 6.55995 9.6304 6.76155V4.80315ZM10.2064 7.63515V9.86235C10.8784 9.78555 11.3584 9.36315 11.3584 8.71035C11.3584 8.07675 10.9072 7.83675 10.2064 7.63515Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.99995H18V2.19995H2V2.99995H4V15.8C4 16.9045 4.89543 17.8 6 17.8H14C15.1046 17.8 16 16.9045 16 15.8V2.99995ZM15.2 2.99995H4.8V15.8C4.8 16.4627 5.33726 17 6 17H14C14.6627 17 15.2 16.4627 15.2 15.8V2.99995Z"
        fill="currentColor"
      />
    </svg>
  );
}
